import { http, HttpResponse } from "msw";
import searchMock from "../../../../__mock__/api-proxy/icafe/search.json";

export default [
  http.get("/api-proxy/icafe/search", async ({ request }) => {
    return HttpResponse.json(searchMock);
  }),
];
